import { useCallback, useLayoutEffect, useRef, useState } from 'react';

// One resolver owns the approval. Closing, navigation and unmount all cancel it.
export default function useChatActionConfirmation(contextKey) {
  const [action, setAction] = useState(null);
  const pending = useRef(null);
  const mounted = useRef(false);
  const settle = useCallback((approved) => {
    const resolve = pending.current;
    if (!resolve) return;
    pending.current = null;
    setAction(null);
    resolve(approved);
  }, []);

  useLayoutEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      const resolve = pending.current;
      pending.current = null;
      resolve?.(false);
    };
  }, []);

  useLayoutEffect(() => {
    settle(false);
  }, [contextKey, settle]);

  const requestConfirmation = useCallback((snapshot) => {
    if (!mounted.current || pending.current) return Promise.resolve(false);
    return new Promise((resolve) => {
      pending.current = resolve;
      setAction(snapshot);
    });
  }, []);

  return { action, requestConfirmation, onCancel: () => settle(false), onConfirm: () => settle(true) };
}
